import { render } from "./Team_en.vue?vue&type=template&id=51fa8562"
import script from "./Team_en.vue?vue&type=script&lang=js"
export * from "./Team_en.vue?vue&type=script&lang=js"
script.render = render

export default script